'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.buildLocalizedGoogleMapsUrl = exports.buildGoogleMapsUrl = exports.GoogleMapsFields = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleMapsFields = exports.GoogleMapsFields = {
	language: 'hl',
	latLng: 'll'
};

var buildGoogleMapsUrl = exports.buildGoogleMapsUrl = function buildGoogleMapsUrl() {
	var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var query = _queryString2.default.stringify(params);
	var fullQuery = query.length > 0 ? '?' + query : '';
	return 'https://maps.google.com/' + fullQuery;
};

var buildLocalizedGoogleMapsUrl = exports.buildLocalizedGoogleMapsUrl = function buildLocalizedGoogleMapsUrl(i18n) {
	var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	return buildGoogleMapsUrl((0, _extends4.default)((0, _defineProperty3.default)({}, GoogleMapsFields.language, i18n.getGoogleLanguage()), params));
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/GoogleMapsUtils.js
// module id = 461
// module chunks = 0